import React, { useState, useEffect } from "react";

const Namuna10 = () => {
  // Bank options dropdown data
  const bankOptions = [
    "स्टेट बँक ऑफ इंडिया (SBI)",
    "ICICI बँक",
    "HDFC बँक",
    "एक्सिस बँक",
    "बँक ऑफ इंडिया",
    "पंजाब नॅशनल बँक (PNB)",
    "बँक ऑफ बड़ौदा",
    "इंडियन बँक",
    "यूनियन बँक ऑफ इंडिया",
    "सेंट्रल बँक ऑफ इंडिया",
    "इंडियन ओव्हरसीज बँक",
    "विजया बँक",
    "कोऑपरेटिव्ह बँक",
    "इतर",
  ];

  const branchOptions = [
    "मुख्य शाखा",
    "शहर शाखा",
    "ग्रामीण शाखा",
    "उप-शाखा",
    "विशेष शाखा",
  ];

  const accountTypeOptions = [
    "बचत खाता",
    "चालू खाता",
    "सावधि खाता",
    "आवर्ती जमा",
    "डिजिटल वॉलेट",
    "सरकारी योजना खाता",
  ];

  const statusOptions = [
    "मंजूर केलेली",
    "प्रलंबित",
    "नाकारली",
    "पुनर्विचार"
  ];

  // Load data from localStorage on mount
  const [records, setRecords] = useState(() => {
    const savedRecords = localStorage.getItem("grampanchayat_namuna10");
    return savedRecords ? JSON.parse(savedRecords) : [];
  });

  // Load wards from localStorage
  const [wards, setWards] = useState(() => {
    const savedRecords = localStorage.getItem("grampanchayat_namuna10");
    if (savedRecords) {
      const data = JSON.parse(savedRecords);
      return [...new Set(data.map(r => r.wardNo))];
    }
    return [];
  });

  const [showForm, setShowForm] = useState(false);
  const [searchWardNo, setSearchWardNo] = useState("");
  const [formData, setFormData] = useState({
    date: "",
    wardNo: "",
    gataNo: "",
    builderName: "",
    propertyAddress: "",
    totalArea: "",
    taxAmount: "",
    bankName: "",
    branchName: "",
    accountType: "",
    accountNumber: "",
    ifscCode: "",
    status: "",
    remarks: ""
  });

  // Compute gatas dynamically based on selected ward
  const gatas = formData.wardNo && formData.wardNo !== "नवीन"
    ? [...new Set(records.filter(r => r.wardNo === formData.wardNo).map(r => r.gataNo))]
    : [];

  // Save records to localStorage whenever records array changes
  useEffect(() => {
    localStorage.setItem("grampanchayat_namuna10", JSON.stringify(records));
  }, [records]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.date || !formData.wardNo || !formData.gataNo || !formData.builderName || 
        !formData.propertyAddress || !formData.totalArea || !formData.taxAmount || 
        !formData.bankName || !formData.accountNumber || !formData.ifscCode || !formData.status) {
      alert("❌ कृपया सर्व आवश्यक माहिती भरा!");
      return;
    }

    setRecords([...records, { ...formData, id: Date.now() }]);

    setFormData({
      date: "",
      wardNo: "",
      gataNo: "",
      builderName: "",
      propertyAddress: "",
      totalArea: "",
      taxAmount: "",
      bankName: "",
      branchName: "",
      accountType: "",
      accountNumber: "",
      ifscCode: "",
      status: "",
      remarks: ""
    });

    alert("✅ मालमत्ता नोंद यशस्वीरित्या जोडली गेली!");
    setShowForm(false);
  };

  const deleteRecord = (id) => {
    const updated = records.filter((record) => record.id !== id);
    setRecords(updated);
  };

  const handleReset = () => {
    setFormData({
      date: "",
      wardNo: "",
      gataNo: "",
      builderName: "",
      propertyAddress: "",
      totalArea: "",
      taxAmount: "",
      bankName: "",
      branchName: "",
      accountType: "",
      accountNumber: "",
      ifscCode: "",
      status: "",
      remarks: ""
    });
  };

  const getStatusColor = (status) => {
    switch(status) {
      case "मंजूर केलेली": return "#28a745";
      case "प्रलंबित": return "#ffc107";
      case "नाकारली": return "#dc3545";
      case "पुनर्विचार": return "#17a2b8";
      default: return "#6c757d";
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      {/* HEADER */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "2rem",
        backgroundColor: "linear-gradient(135deg, #6f42c1 0%, #8a5fcf 100%)",
        backgroundImage: "linear-gradient(135deg, #6f42c1 0%, #8a5fcf 100%)",
        color: "white",
        padding: "1.5rem 2rem",
        borderRadius: "0.75rem",
        boxShadow: "0 4px 6px rgba(0,0,0,0.15)"
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: "700", letterSpacing: "0.5px" }}>
            🏛️ नमुना नं १० - मालमत्ता नोंदणी
          </h2>
          <p style={{ margin: "0.5rem 0 0 0", fontSize: "0.95rem", opacity: 0.9 }}>
            मालमत्ता आणि बँक खाते माहिती व्यवस्थापन
          </p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            backgroundColor: showForm ? "#dc3545" : "#28a745",
            color: "white",
            border: "none",
            padding: "0.7rem 1.5rem",
            borderRadius: "25px",
            cursor: "pointer",
            fontSize: "0.95rem",
            fontWeight: "600",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            transform: "translateY(0)"
          }}
          onMouseOver={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
          }}
          onMouseOut={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
          }}
        >
          {showForm ? "✕ बंद करा" : "➕ नवीन नोंद"}
        </button>
      </div>

      {/* SEARCH FILTER */}
      <div style={{ marginBottom: "2rem" }}>
        <input
          type="text"
          placeholder="🔍 वार्ड क्रमांकानुसार शोधा..."
          value={searchWardNo}
          onChange={(e) => setSearchWardNo(e.target.value)}
          style={{
            width: "100%",
            maxWidth: "400px",
            padding: "0.75rem 1rem",
            border: "2px solid #e9ecef",
            borderRadius: "0.4rem",
            fontSize: "0.95rem",
            transition: "border-color 0.3s"
          }}
          onFocus={(e) => e.target.style.borderColor = "#6f42c1"}
          onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
        />
      </div>

      {/* FORM */}
      {showForm && (
        <form onSubmit={handleSubmit} style={{
          backgroundColor: "white",
          padding: "2rem",
          marginBottom: "2rem",
          borderRadius: "0.75rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          border: "1px solid #e9ecef"
        }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "1.5rem" }}>
            
            {/* Property Section */}
            <h4 style={{ gridColumn: "1/-1", color: "#6f42c1", borderBottom: "2px solid #6f42c1", paddingBottom: "0.5rem" }}>
              📍 मालमत्ता माहिती
            </h4>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                📅 दिनांक <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input type="date" name="date" value={formData.date} onChange={handleChange} required
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              />
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                🏘️ वार्ड क्रमांक <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <select name="wardNo" value={formData.wardNo} onChange={handleChange} required
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              >
                <option value="">-- वार्ड निवडा --</option>
                {wards.map((ward) => (
                  <option key={ward} value={ward}>{ward}</option>
                ))}
                <option value="नवीन">+ नवीन वार्ड जोडा</option>
              </select>
              {formData.wardNo === "नवीन" && (
                <input type="text" placeholder="नवीन वार्ड नाव" 
                  style={{ width: "100%", padding: "0.75rem", marginTop: "0.5rem", border: "2px solid #e9ecef", borderRadius: "0.4rem" }}
                  onChange={(e) => setFormData({ ...formData, wardNo: e.target.value })}
                />
              )}
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                📋 गट क्रमांक <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <select name="gataNo" value={formData.gataNo} onChange={handleChange} required
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              >
                <option value="">-- गट निवडा --</option>
                {gatas.map((gata) => (
                  <option key={gata} value={gata}>{gata}</option>
                ))}
                <option value="नवीन">+ नवीन गट जोडा</option>
              </select>
              {formData.gataNo === "नवीन" && (
                <input type="text" placeholder="नवीन गट क्रमांक" 
                  style={{ width: "100%", padding: "0.75rem", marginTop: "0.5rem", border: "2px solid #e9ecef", borderRadius: "0.4rem" }}
                  onChange={(e) => setFormData({ ...formData, gataNo: e.target.value })}
                />
              )}
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                👷 बिल्डर/मालक नाव <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input type="text" name="builderName" value={formData.builderName} onChange={handleChange} required
                placeholder="नाव" style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              />
            </div>

            <div style={{ gridColumn: "1/-1" }}>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                🏠 मालमत्ता पत्ता <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <textarea name="propertyAddress" value={formData.propertyAddress} onChange={handleChange} required
                placeholder="संपूर्ण पत्ता" rows="2"
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem", fontFamily: "inherit" }}
              />
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                📐 एकूण क्षेत्रफळ <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input type="number" name="totalArea" value={formData.totalArea} onChange={handleChange} required
                placeholder="चौ. मी." step="0.01" style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              />
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                💰 कर रक्कम <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input type="number" name="taxAmount" value={formData.taxAmount} onChange={handleChange} required
                placeholder="रक्कम" step="0.01" style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              />
            </div>

            {/* Bank Section */}
            <h4 style={{ gridColumn: "1/-1", color: "#6f42c1", borderBottom: "2px solid #6f42c1", paddingBottom: "0.5rem", marginTop: "1rem" }}>
              🏦 बँक माहिती
            </h4>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                बँकेचे नाव <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <select name="bankName" value={formData.bankName} onChange={handleChange} required
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              >
                <option value="">-- बँक निवडा --</option>
                {bankOptions.map((bank) => (
                  <option key={bank} value={bank}>{bank}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                शाखेचे नाव
              </label>
              <select name="branchName" value={formData.branchName} onChange={handleChange}
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              >
                <option value="">-- शाखा निवडा --</option>
                {branchOptions.map((branch) => (
                  <option key={branch} value={branch}>{branch}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                खाते प्रकार
              </label>
              <select name="accountType" value={formData.accountType} onChange={handleChange}
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              >
                <option value="">-- खाते प्रकार निवडा --</option>
                {accountTypeOptions.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                खाते क्रमांक <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input type="text" name="accountNumber" value={formData.accountNumber} onChange={handleChange} required
                placeholder="खाते क्रमांक" style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              />
            </div>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                IFSC कोड <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input type="text" name="ifscCode" value={formData.ifscCode} onChange={handleChange} required
                placeholder="IFSC कोड" style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              />
            </div>

            {/* Status Section */}
            <h4 style={{ gridColumn: "1/-1", color: "#6f42c1", borderBottom: "2px solid #6f42c1", paddingBottom: "0.5rem", marginTop: "1rem" }}>
              ✅ स्थिती आणि टिप्पणी
            </h4>

            <div>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                स्थिती <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <select name="status" value={formData.status} onChange={handleChange} required
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem" }}
              >
                <option value="">-- स्थिती निवडा --</option>
                {statusOptions.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </div>

            <div style={{ gridColumn: "1/-1" }}>
              <label style={{ fontWeight: "600", color: "#6f42c1", marginBottom: "0.5rem", display: "block" }}>
                टिप्पणी/विवरण
              </label>
              <textarea name="remarks" value={formData.remarks} onChange={handleChange}
                placeholder="अतिरिक्त टिप्पणी" rows="2"
                style={{ width: "100%", padding: "0.75rem", border: "2px solid #e9ecef", borderRadius: "0.4rem", fontSize: "0.95rem", fontFamily: "inherit" }}
              />
            </div>
          </div>

          <div style={{ display: "flex", gap: "1rem", marginTop: "2rem", justifyContent: "center" }}>
            <button type="submit" style={{
              padding: "0.75rem 2rem",
              backgroundColor: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "25px",
              fontSize: "0.95rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s"
            }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#218838";
                e.target.style.boxShadow = "0 4px 8px rgba(40, 167, 69, 0.5)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#28a745";
                e.target.style.boxShadow = "none";
              }}
            >
              💾 जतन करा
            </button>
            <button type="button" onClick={handleReset} style={{
              padding: "0.75rem 2rem",
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "25px",
              fontSize: "0.95rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s"
            }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#5a6268";
                e.target.style.boxShadow = "0 4px 8px rgba(108, 117, 125, 0.5)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#6c757d";
                e.target.style.boxShadow = "none";
              }}
            >
              🔄 रीसेट करा
            </button>
          </div>
        </form>
      )}

      {/* STATISTICS */}
      <div style={{ display: "flex", gap: "2rem", marginBottom: "2rem", padding: "1rem", backgroundColor: "#f8f9fa", borderRadius: "0.5rem" }}>
        <div style={{ fontSize: "1rem" }}>
          <span style={{ color: "#666" }}>एकूण नोंदी:</span>
          <strong style={{ fontSize: "1.3rem", color: "#6f42c1", marginLeft: "0.5rem" }}>{records.length}</strong>
        </div>
        {searchWardNo && (
          <div style={{ fontSize: "1rem" }}>
            <span style={{ color: "#666" }}>शोध परिणाम:</span>
            <strong style={{ fontSize: "1.3rem", color: "#6f42c1", marginLeft: "0.5rem" }}>
              {records.filter((r) => r.wardNo.toLowerCase().includes(searchWardNo.toLowerCase())).length}
            </strong>
          </div>
        )}
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto", backgroundColor: "white", borderRadius: "0.75rem", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" }}>
          <thead>
            <tr style={{ backgroundColor: "#6f42c1", color: "white" }}>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>क्र.</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>दिनांक</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>वार्ड</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>गट</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>बिल्डर</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>पत्ता</th>
              <th style={{ padding: "1rem", textAlign: "center", borderBottom: "2px solid #e9ecef" }}>क्षेत्र</th>
              <th style={{ padding: "1rem", textAlign: "center", borderBottom: "2px solid #e9ecef" }}>कर रक्कम</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>बँक</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>खाता प्रकार</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>खाता क्रमांक</th>
              <th style={{ padding: "1rem", textAlign: "left", borderBottom: "2px solid #e9ecef" }}>IFSC</th>
              <th style={{ padding: "1rem", textAlign: "center", borderBottom: "2px solid #e9ecef" }}>स्थिती</th>
              <th style={{ padding: "1rem", textAlign: "center", borderBottom: "2px solid #e9ecef" }}>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan="14" style={{ padding: "2rem", textAlign: "center", color: "#999" }}>
                  📭 कोणतीही नोंद उपलब्ध नाही
                </td>
              </tr>
            ) : searchWardNo && !records.some(r => r.wardNo.toLowerCase().includes(searchWardNo.toLowerCase())) ? (
              <tr>
                <td colSpan="14" style={{ padding: "2rem", textAlign: "center", color: "#999" }}>
                  🔍 "{searchWardNo}" साठी कोणतीही नोंद सापडली नाही
                </td>
              </tr>
            ) : (
              records
                .filter(r => r.wardNo.toLowerCase().includes(searchWardNo.toLowerCase()))
                .map((record, index) => (
                  <tr key={record.id} style={{ borderBottom: "1px solid #e9ecef", backgroundColor: index % 2 === 0 ? "#f8f9fa" : "white" }}>
                    <td style={{ padding: "0.75rem 1rem" }}>{index + 1}</td>
                    <td style={{ padding: "0.75rem 1rem" }}>{record.date}</td>
                    <td style={{ padding: "0.75rem 1rem" }}>{record.wardNo}</td>
                    <td style={{ padding: "0.75rem 1rem" }}>{record.gataNo}</td>
                    <td style={{ padding: "0.75rem 1rem" }}>{record.builderName}</td>
                    <td style={{ padding: "0.75rem 1rem", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={record.propertyAddress}>{record.propertyAddress}</td>
                    <td style={{ padding: "0.75rem 1rem", textAlign: "center" }}>{record.totalArea}</td>
                    <td style={{ padding: "0.75rem 1rem", textAlign: "center" }}>₹ {parseFloat(record.taxAmount || 0).toFixed(2)}</td>
                    <td style={{ padding: "0.75rem 1rem" }}>{record.bankName}</td>
                    <td style={{ padding: "0.75rem 1rem" }}>{record.accountType}</td>
                    <td style={{ padding: "0.75rem 1rem", fontFamily: "monospace" }}>{record.accountNumber}</td>
                    <td style={{ padding: "0.75rem 1rem", fontFamily: "monospace" }}>{record.ifscCode}</td>
                    <td style={{ padding: "0.75rem 1rem", textAlign: "center" }}>
                      <span style={{
                        display: "inline-block",
                        padding: "0.4rem 0.8rem",
                        borderRadius: "20px",
                        backgroundColor: getStatusColor(record.status),
                        color: "white",
                        fontSize: "0.85rem",
                        fontWeight: "600"
                      }}>
                        {record.status}
                      </span>
                    </td>
                    <td style={{ padding: "0.75rem 1rem", textAlign: "center" }}>
                      <button onClick={() => deleteRecord(record.id)} style={{
                        padding: "0.4rem 0.8rem",
                        backgroundColor: "#dc3545",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "0.85rem",
                        transition: "all 0.3s"
                      }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = "#c82333";
                          e.target.style.boxShadow = "0 2px 4px rgba(220, 53, 69, 0.5)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = "#dc3545";
                          e.target.style.boxShadow = "none";
                        }}
                      >
                        🗑️ हटवा
                      </button>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Namuna10;
